// First-touch lead attribution — captured once per session, sent with every inquiry.
const KEY = "gd_lead_source";

export function initLeadSource() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const source = {
      landing_path: window.location.pathname,
      referrer: document.referrer || null,
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      captured_at: new Date().toISOString(),
    };
    sessionStorage.setItem(KEY, JSON.stringify(source));
  } catch {
    /* storage unavailable — attribution is best-effort */
  }
}

export function getLeadSource() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
